import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import reportWebVitals from "./reportWebVitals"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import ErrorPage from "./error-page"
import App from "./App"
import RootRedirect from "./components/shared/RootRedirect"
import RedirectToAnalysis from "./components/shared/RedirectToAnalysis"
import Index from "./routes/index"
import Contact from "./routes/contact-us"
import Pricing from "./routes/pricing"
import Dashboard from "./routes/dashboard"
import Checker from "./routes/checker"
import Convoy from "./routes/convoy"
import Settings from "./routes/settings"
import SafetyProfile from "./routes/safety-profile"
import UserRegister from "./routes/user-register"
import UserLogin from "./routes/user-login"
import ForgotPassword from "./routes/forgot-password"
import ResetPassword from "./routes/reset-password"
import Join from "./routes/join"
import ProtectedRoute from "./components/shared/ProtectedRoute"
import ExternalRedirect from "./components/shared/ExternalRedirect"

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        errorElement: <ErrorPage />,
        children: [
            { index: true, element: <RootRedirect /> },
            {
                path: "contact",
                element: <Contact />,
            },
            // About, Privacy and Terms live on getchaperon.com (plan B2.3).
            // server.js answers direct visits with a 301; these cover in-app
            // links, which never reach the server.
            ...["about", "privacy", "terms"].map((path) => ({
                path,
                element: <ExternalRedirect to={`https://getchaperon.com/${path}`} />,
            })),
            {
                path: "pricing",
                element: <Pricing />,
            },
            {
                path: "analysis/:slug/*",
                element: <SafetyProfile />,
            },
            // Formerly the live URL for this page (still linked from
            // outside the app -- bookmarks, shared links, search engine
            // results), so it redirects rather than 404ing.
            {
                path: "safety/:slug/*",
                element: <RedirectToAnalysis />,
            },
            {
                path: "community",
                element: (
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                ),
            },
            {
                path: "dashboard",
                element: (
                    <ProtectedRoute>
                        <Index />
                    </ProtectedRoute>
                ),
            },
            {
                path: "community/checker",
                element: (
                    <ProtectedRoute>
                        <Checker />
                    </ProtectedRoute>
                ),
            },
            {
                path: "community/convoy",
                element: (
                    <ProtectedRoute>
                        <Convoy />
                    </ProtectedRoute>
                ),
            },
            {
                path: "settings",
                element: (
                    <ProtectedRoute>
                        <Settings />
                    </ProtectedRoute>
                ),
            },
            {
                path: "user/register",
                element: <UserRegister />,
            },
            {
                path: "user/login",
                element: <UserLogin />,
            },
            {
                path: "user/forgot-password",
                element: <ForgotPassword />,
            },
            {
                path: "user/reset-password",
                element: <ResetPassword />,
            },
            {
                path: "join/:token",
                element: <Join />,
            },
        ],
    },
])

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <RouterProvider router={router} />
        </HelmetProvider>
    </React.StrictMode>,
)

// Remove <React.StrictMode> from the root render method to prevent double rendering of the app.

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
